import { render, staticRenderFns } from "./TextAreaQuestion.vue?vue&type=template&id=5daaeb18&"
import script from "./TextAreaQuestion.vue?vue&type=script&lang=ts&"
export * from "./TextAreaQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5daaeb18')) {
      api.createRecord('5daaeb18', component.options)
    } else {
      api.reload('5daaeb18', component.options)
    }
    module.hot.accept("./TextAreaQuestion.vue?vue&type=template&id=5daaeb18&", function () {
      api.rerender('5daaeb18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountApplication/accountApplicationForm/typesOfQuestion/TextAreaQuestion.vue"
export default component.exports